/**
 * Founder page — shared scroll reveal (FadeIn parity)
 */
(function () {
  function enhance(root) {
    if (!root || root._vgFounderReveal) return;
    root._vgFounderReveal = true;
    var nodes = root.querySelectorAll('[data-founder-reveal]');
    if (!nodes.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      nodes.forEach(function (n) {
        n.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '-80px 0px' }
    );
    nodes.forEach(function (n) {
      io.observe(n);
    });
  }

  function initAll() {
    document
      .querySelectorAll(
        '[data-section-type^="founder-"]'
      )
      .forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target.querySelector &&
        event.target.querySelector('[data-section-type^="founder-"]')) ||
      null;
    if (
      !root &&
      event.target.getAttribute &&
      (event.target.getAttribute('data-section-type') || '').indexOf('founder-') === 0
    ) {
      root = event.target;
    }
    if (root) {
      root._vgFounderReveal = false;
      enhance(root);
    }
  });
})();
